import ColorStop from './colorStop';
import Color from './color';
import { clone, map, sortBy, sortedIndex } from 'lodash-es';

export default class HeatMap {
  static default = new HeatMap([
    new ColorStop(Color.fromHex('#3184FF'), 0),
    new ColorStop(Color.fromHex('#46D2D7'), 0.25),
    new ColorStop(Color.fromHex('#FFD800'), 0.5),
    new ColorStop(Color.fromHex('#FF6A00'), 0.85),
    new ColorStop(Color.fromHex('#FF0000'), 1)
  ]);

  private readonly _stops: ColorStop[];
  private readonly _ratios: number[];

  constructor(stops: ColorStop[]) {
    this._stops = sortBy(stops, (s) => s.ratio);
    this._ratios = map(this._stops, (s) => s.ratio);
  }

  getColor(value: number, min = 0, max = 300) {
    const clampedValue = Math.min(Math.max(value, min), max);
    const ratio = (clampedValue - min) / (max - min);

    const minColorIndex = Color.clamp(
      //
      sortedIndex(this._ratios, ratio) - 1,
      0,
      this._stops.length - 1
    );
    const maxColorIndex = Math.min(minColorIndex + 1, this._stops.length - 1);

    const minColor = this._stops[minColorIndex].color;
    const maxColor = this._stops[maxColorIndex].color;
    const ratioBetweenColors = (ratio - this._ratios[minColorIndex]) / (this._ratios[maxColorIndex] - this._ratios[minColorIndex]);

    const newRed = minColor.r + (maxColor.r - minColor.r) * ratioBetweenColors;
    const newGreen = minColor.g + (maxColor.g - minColor.g) * ratioBetweenColors;
    const newBlue = minColor.b + (maxColor.b - minColor.b) * ratioBetweenColors;

    return new Color(newRed, newGreen, newBlue);
  }

  get colorStops(): ColorStop[] {
    return map(this._stops, clone);
  }
}
